import React from "react";

const attendanceData = [
  { date: "Oct 23, 2025", inTime: "7:00 AM", outTime: "4:15 PM", lunch: "60 mins", totalHours: "8.25 hrs" },
  { date: "Oct 22, 2025", inTime: "6:55 AM", outTime: "4:05 PM", lunch: "60 mins", totalHours: "8.17 hrs" },
  { date: "Oct 21, 2025", inTime: "7:45 AM", outTime: "4:30 PM", lunch: "45 mins", totalHours: "8.00 hrs" },
  { date: "Oct 20, 2025", inTime: "7:00 AM", outTime: "4:10 PM", lunch: "60 mins", totalHours: "8.13 hrs" },
  { date: "Oct 19, 2025", inTime: "6:58 AM", outTime: "4:05 PM", lunch: "60 mins", totalHours: "8.12 hrs" },
];

export default function RecentAttendanceList() {
  const startHour = "7:00 AM";

  const timeToMinutes = (timeStr) => {
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);
    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;
    return hours * 60 + minutes;
  };

  return (
    <div>
      <h4 className="text-sm font-semibold mb-3">Recent Attendance Records</h4>
      <p className="text-xs mb-3">Standard Working Hours: {startHour} - 4:00 PM</p>

      <div className="space-y-2">
        {attendanceData.map((item, index) => {
          const startMinutes = timeToMinutes(startHour);
          const inMinutes = timeToMinutes(item.inTime);

          let status = "On Time";
          let lateDuration = null;

          if (inMinutes > startMinutes) {
            status = "Late";
            const lateMins = inMinutes - startMinutes;
            const hours = Math.floor(lateMins / 60);
            const mins = lateMins % 60;
            lateDuration = hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
          }

          const isLate = status === "Late";

          return (
            <div
              key={index}
              className="p-3 border border-slate-200 rounded-xl hover:shadow-md transition-all bg-white"
            >
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <p className="font-semibold text-sm">{item.date}</p>
                    <span
                      className={`font-semibold gap-1 status-indicator ${status
                        .toLowerCase()
                        .replace(/[^a-z0-9]+/g, "-")} text-[10px]`}
                    >
                      {status}
                      {isLate && lateDuration && (
                        <span>
                          ({lateDuration})
                        </span>
                      )}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-3 text-xs">
                    <span>
                      In: <span className="font-medium">{item.inTime}</span>
                    </span>
                    <span>•</span>
                    <span>
                      Out: <span className="font-medium">{item.outTime}</span>
                    </span>
                    <span>•</span>
                    <span>
                      Lunch: <span className="font-medium">{item.lunch}</span>
                    </span>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xs">Total Hours</p>
                  <p className="text-lg font-bold text-emerald-600">{item.totalHours}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
